/* Banner efektleri (referans temadaki karsiliklari):

   1) Parallax: referansta data-js-parallax + --parallax-strength ile arka plan
      sayfa kayarken yavas hareket ediyor. Ayni etki burada da var; hesap
      requestAnimationFrame icinde yapiliyor ki scroll takilmasin.
   2) Bulanik on yukleme (pixelate preloader): gorsel yuklenene kadar bulanik
      durur, yuklenince netlesir. Boylece bos beyaz alan gorunmez.
*/

(function () {
  const parallaxItems = [];
  let ticking = false;

  const apply = () => {
    ticking = false;
    const viewportHeight = window.innerHeight;

    for (const item of parallaxItems) {
      const rect = item.el.getBoundingClientRect();
      // Bolum ekranda degilse hesap yapma
      if (rect.bottom < -200 || rect.top > viewportHeight + 200) continue;

      // ilerleme: bolum ekrana girerken 0, cikarken 1
      const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
      const clamped = Math.min(Math.max(progress, 0), 1);
      // -strength ile +strength arasinda kaydir
      const shift = (clamped * 2 - 1) * item.strength;
      item.el.style.transform = `translate3d(0, ${shift}%, 0)`;
    }
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(apply);
  };

  const initParallax = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-btrio-parallax]').forEach((el) => {
      if (el.dataset.btrioReady === 'true') return;
      const raw = getComputedStyle(el).getPropertyValue('--btrio_parallax').trim();
      const strength = parseFloat(raw) || 0;
      if (strength === 0) return;
      el.dataset.btrioReady = 'true';
      parallaxItems.push({ el, strength });
    });

    if (!parallaxItems.length) return;
    apply();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  };

  const initBlurUp = () => {
    document.querySelectorAll('[data-btrio-img]').forEach((img) => {
      // Tarayici onbellekten aninda yuklemis olabilir
      if (img.complete && img.naturalWidth > 0) {
        img.classList.remove('is-loading');
        return;
      }
      img.addEventListener('load', () => img.classList.remove('is-loading'), { once: true });
      // Yuklenemezse de bulanik kalmasin
      img.addEventListener('error', () => img.classList.remove('is-loading'), { once: true });
    });
  };

  const init = () => {
    initParallax();
    initBlurUp();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/* Kategori uzerine gelince arka plan gorselinin capraz gecisle degismesi.

   Neden iki katman: bir <img>'in src'sini degistirmek animasyonlanamaz
   (tarayici ara kare uretmez). Iki katman sirayla acilip kapaniyor; yeni
   gorsel gorunmeden once new Image() ile onbellege alindigi icin gecis
   sirasinda bos kare olusmuyor. */

(function () {
  const setupCard = (card) => {
    if (card.dataset.btrioSwapReady === 'true') return;
    const layers = card.querySelectorAll('[data-btrio-layer]');
    const links = card.querySelectorAll('[data-btrio-link-img]');
    if (layers.length < 2 || !links.length) return;
    card.dataset.btrioSwapReady = 'true';

    let restoreTimer = null;

    const crossfade = (src) => {
      // Gorunur olmayan katmani hazirla, sonra one al
      const hidden = Array.from(layers).find((l) => !l.classList.contains('is-visible')) || layers[0];
      const other = Array.from(layers).find((l) => l !== hidden);
      if (hidden.dataset.src === src && hidden.classList.contains('is-visible')) return;

      const pre = new Image();
      pre.onload = () => {
        hidden.src = src;
        hidden.dataset.src = src;
        hidden.classList.add('is-visible');
        if (other) other.classList.remove('is-visible');
      };
      pre.src = src;
    };

    const restore = () => {
      layers.forEach((l) => l.classList.remove('is-visible'));
    };

    links.forEach((link) => {
      link.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'touch') return;
        if (restoreTimer) clearTimeout(restoreTimer);
        crossfade(link.dataset.btrioLinkImg);
      });
      link.addEventListener('focus', () => crossfade(link.dataset.btrioLinkImg));
    });

    // Kart terk edilince asil gorsele don; kisa gecikme link arasi gecislerde
    // gereksiz geri donusu engeller
    card.addEventListener('pointerleave', () => {
      restoreTimer = setTimeout(restore, 140);
    });
    card.addEventListener('focusout', (event) => {
      if (!card.contains(event.relatedTarget)) restore();
    });

    // Dokunmatik ekranlarda "fareyle uzerine gelme" diye bir sey yok, bu
    // yuzden kategori gorselleri kendi kendine, sirayla, birer birer
    // degisiyor - kullanicinin gorebilmesi icin.
    const hasHover = window.matchMedia('(hover: hover)').matches;
    if (!hasHover && links.length > 1) {
      let index = 0;
      setInterval(() => {
        index = (index + 1) % links.length;
        crossfade(links[index].dataset.btrioLinkImg);
      }, 2600);
    }
  };

  const init = () => document.querySelectorAll('.btrio--card').forEach(setupCard);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
